var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 266.578 266.578"
    },
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.292 6.963c1.699 0 3.08 -1.382 3.08 -3.08C7.372 2.184 5.99 0.802 4.292 0.802c-1.698 0 -3.08 1.382 -3.08 3.081 0 1.699 1.382 3.08 3.08 3.08zm0 -5.143c1.137 0 2.062 0.925 2.062 2.063 0 1.137 -0.925 2.062 -2.062 2.062 -1.137 0 -2.062 -0.925 -2.062 -2.062 0 -1.137 0.925 -2.063 2.062 -2.063z",
    stroke: "#BCD4CF",
    fill: "#BCD4CF",
    strokeWidth: 0.112537418691715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.326 19.521v9.167a0.509 0.509 0 1 0 1.018 0v-9.43c0 -0.008 -0.001 -0.016 -0.001 -0.023a0.509 0.509 0 0 0 -0.27 -0.452c-0.651 -0.347 -1.056 -1.017 -1.056 -1.75v-5.595c0 -1.092 0.888 -1.98 1.98 -1.98H5.607c1.092 0 1.98 0.888 1.98 1.98v5.595c0 0.733 -0.405 1.403 -1.056 1.75a0.509 0.509 0 0 0 -0.269 0.463q0 0.006 -0.001 0.012v9.43a0.509 0.509 0 1 0 1.018 0v-9.168c0.825 -0.555 1.326 -1.482 1.326 -2.487v-5.595C8.604 9.785 7.26 8.44 5.607 8.44H2.998C1.345 8.441 0 9.786 0 11.439v5.595c0 1.005 0.501 1.932 1.326 2.487z",
    stroke: "#BCD4CF",
    fill: "#BCD4CF",
    strokeWidth: 0.112537418691715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.042 13.917c1.699 0 3.081 -1.382 3.081 -3.081s-1.382 -3.081 -3.081 -3.081c-1.698 0 -3.08 1.382 -3.08 3.081s1.382 3.081 3.08 3.081zm0 -5.144c1.137 0 2.063 0.925 2.063 2.063 0 1.138 -0.925 2.063 -2.063 2.063 -1.137 0 -2.062 -0.926 -2.062 -2.063 0 -1.137 0.925 -2.063 2.062 -2.063z",
    stroke: "#BCD4CF",
    fill: "#BCD4CF",
    strokeWidth: 0.112537418691715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.879 23.8v4.889a0.509 0.509 0 1 0 1.018 0v-5.151c0 -0.008 -0.001 -0.016 -0.001 -0.023a0.509 0.509 0 0 0 -0.269 -0.452c-0.651 -0.347 -1.056 -1.018 -1.056 -1.75V18.392c0 -1.092 0.888 -1.98 1.98 -1.98h1.004c1.092 0 1.98 0.888 1.98 1.98v2.921c0 0.733 -0.405 1.403 -1.056 1.75a0.509 0.509 0 0 0 -0.269 0.463c0 0.004 -0.001 0.008 -0.001 0.012v5.151a0.509 0.509 0 1 0 1.018 0v-4.889c0.825 -0.556 1.326 -1.482 1.326 -2.487V18.392c0 -1.653 -1.345 -2.998 -2.998 -2.998h-1.004c-1.653 0 -2.998 1.345 -2.998 2.998v2.921c0 1.005 0.501 1.932 1.327 2.487z",
    stroke: "#BCD4CF",
    fill: "#BCD4CF",
    strokeWidth: 0.112537418691715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.349 8.568c1.699 0 3.08 -1.382 3.08 -3.08 0 -1.699 -1.382 -3.082 -3.08 -3.082 -1.699 0 -3.081 1.382 -3.081 3.082 0 1.698 1.382 3.08 3.081 3.08zm0 -5.144c1.137 0 2.062 0.926 2.062 2.064 0 1.137 -0.925 2.062 -2.062 2.062 -1.137 0 -2.063 -0.925 -2.063 -2.062 0 -1.138 0.925 -2.064 2.063 -2.064z",
    stroke: "#BCD4CF",
    fill: "#BCD4CF",
    strokeWidth: 0.112537418691715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.207 21.347h2.979v7.341a0.509 0.509 0 1 0 1.018 0v-7.85a0.518 0.518 0 0 0 -0.023 -0.151 0.509 0.509 0 0 0 -0.486 -0.358h-2.664l2.306 -4.613c0.035 -0.071 0.054 -0.149 0.054 -0.228v-2.467c0 -1.079 0.879 -1.958 1.958 -1.958 1.08 0 1.958 0.878 1.958 1.958v2.467c0 0.079 0.018 0.157 0.054 0.228l2.306 4.613h-2.643a0.509 0.509 0 0 0 -0.509 0.509v7.85a0.509 0.509 0 1 0 1.018 0V21.347h2.958a0.51 0.51 0 0 0 0.433 -0.241 0.51 0.51 0 0 0 0.022 -0.495l-2.621 -5.243v-2.347c0 -1.641 -1.335 -2.976 -2.976 -2.976 -1.641 0 -2.976 1.335 -2.976 2.976v2.347l-2.621 5.243a0.509 0.509 0 0 0 0.455 0.737z",
    stroke: "#BCD4CF",
    fill: "#BCD4CF",
    strokeWidth: 0.112537418691715
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.6b7b1fe8b6eac047a807b777b9556b85.svg";
export { ForwardRef as ReactComponent };